module.exports = __webpack_public_path__ + "assets/img/e61ba210cc20e94d050db216daad84bc.svg";